/**
 * Open a same-origin URL in a new browser tab from code (not from an <a> element).
 *
 * - Severs `window.opener` on the new tab (equivalent protection to rel="noopener") while
 *   still letting the caller detect a blocked popup, which `window.open(url, "_blank",
 *   "noopener")` cannot (it always returns null).
 * - Returns true when a tab was opened, false when the browser blocked it, so callers can
 *   fall back to same-tab navigation instead of failing silently.
 *
 * Ordinary navigation links should be real anchors (<Link target="_blank" rel="noopener
 * noreferrer">); this helper is for programmatic opens such as answering a call.
 */
export function openInNewTab(url) {
  if (typeof window === "undefined" || typeof window.open !== "function") return false;
  let win = null;
  try {
    win = window.open(url, "_blank");
  } catch {
    win = null;
  }
  if (!win) return false;
  try {
    win.opener = null;
  } catch {
    /* ignore */
  }
  return true;
}

/**
 * Open a URL in a new tab with `noopener,noreferrer`: no `window.opener`, no Referer, and —
 * unlike a plain `window.open` — the new tab does NOT receive a copy of this tab's
 * sessionStorage (which holds per-tab meeting session tokens). Popup blocking cannot be
 * detected in this mode; use it where no same-tab fallback is required.
 */
export function openInNewTabIsolated(url) {
  if (typeof window === "undefined" || typeof window.open !== "function") return;
  try {
    window.open(url, "_blank", "noopener,noreferrer");
  } catch {
    /* ignore */
  }
}

export default openInNewTab;
